import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Mail, Phone, MapPin } from 'lucide-react';
export function ContactPage() {
  return <div className="bg-brand-beige" data-id="element-497">
      <PageHero title="Contact Us" subtitle="We'd love to hear from you. Reach out with any inquiries." data-id="element-498" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-499">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-500"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-501">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-502">
            {/* Contact Info Cards */}
            <div className="space-y-8" data-id="element-503">
              <motion.div className="bg-white p-8 md:p-10 shadow-xl shadow-brand-dark/5 rounded-sm border-t-4 border-brand-red" initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} data-id="element-504">
                <h3 className="text-2xl font-serif text-brand-dark mb-6" data-id="element-505">
                  General Inquiries
                </h3>
                <div className="space-y-4 text-brand-dark/70 font-light" data-id="element-506">
                  <p className="flex items-center gap-4" data-id="element-507">
                    <Mail size={18} className="text-brand-red" data-id="element-508" />{' '}
                    info@jibekjolugroup.com
                  </p>
                  <p className="flex items-center gap-4" data-id="element-509">
                    <Phone size={18} className="text-brand-red" data-id="element-510" /> +1 (555)
                    123-4567
                  </p>
                  <p className="flex items-center gap-4" data-id="element-511">
                    <MapPin size={18} className="text-brand-red" data-id="element-512" /> 100
                    Hospitality Way, Suite 400
                  </p>
                </div>
              </motion.div>

              <motion.div className="bg-white p-8 md:p-10 shadow-xl shadow-brand-dark/5 rounded-sm border-t-4 border-brand-gold" initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} data-id="element-513">
                <h3 className="text-2xl font-serif text-brand-dark mb-6" data-id="element-514">
                  Private Dining & Events
                </h3>
                <div className="space-y-4 text-brand-dark/70 font-light" data-id="element-515">
                  <p className="flex items-center gap-4" data-id="element-516">
                    <Mail size={18} className="text-brand-gold" data-id="element-517" />{' '}
                    events@jibekjolugroup.com
                  </p>
                  <p className="flex items-center gap-4" data-id="element-518">
                    <Phone size={18} className="text-brand-gold" data-id="element-519" /> +1 (555)
                    123-4568
                  </p>
                </div>
              </motion.div>

              <motion.div className="bg-white p-8 md:p-10 shadow-xl shadow-brand-dark/5 rounded-sm border-t-4 border-brand-terracotta" initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} data-id="element-520">
                <h3 className="text-2xl font-serif text-brand-dark mb-6" data-id="element-521">
                  Press & Media
                </h3>
                <div className="space-y-4 text-brand-dark/70 font-light" data-id="element-522">
                  <p className="flex items-center gap-4" data-id="element-523">
                    <Mail size={18} className="text-brand-terracotta" data-id="element-524" />{' '}
                    press@jibekjolugroup.com
                  </p>
                </div>
              </motion.div>
            </div>

            {/* Contact Form */}
            <motion.div className="bg-brand-dark p-10 md:p-14 rounded-sm shadow-2xl relative" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-525">
              <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-526"></div>
              <div className="relative z-10" data-id="element-527">
                <h3 className="text-3xl font-serif text-white mb-8" data-id="element-528">
                  Send a Message
                </h3>
                <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-529">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-530">
                    <div data-id="element-531">
                      <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-532">
                        First Name
                      </label>
                      <input type="text" className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-533" />
                    </div>
                    <div data-id="element-534">
                      <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-535">
                        Last Name
                      </label>
                      <input type="text" className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-536" />
                    </div>
                  </div>
                  <div data-id="element-537">
                    <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-538">
                      Email Address
                    </label>
                    <input type="email" className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-539" />
                  </div>
                  <div data-id="element-540">
                    <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-541">
                      Subject
                    </label>
                    <select className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors appearance-none" data-id="element-542">
                      <option className="text-brand-dark" data-id="element-543">
                        General Inquiry
                      </option>
                      <option className="text-brand-dark" data-id="element-544">
                        Private Events
                      </option>
                      <option className="text-brand-dark" data-id="element-545">Careers</option>
                      <option className="text-brand-dark" data-id="element-546">Press</option>
                    </select>
                  </div>
                  <div data-id="element-547">
                    <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-548">
                      Message
                    </label>
                    <textarea rows={4} className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors resize-none" data-id="element-549"></textarea>
                  </div>
                  <button className="w-full bg-brand-gold text-brand-dark py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-white transition-colors mt-4" data-id="element-550">
                    Send Message
                  </button>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}